export const templatePostSubmit = String.raw`<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>New recipe — Nemonto</title>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link href="https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap" rel="stylesheet">
<style>
  :root{
    --spice:#D85A30; --spice-deep:#B23D18; --cream:#FAECE7; --peach:#F5C4B3;
    --charcoal:#2C2C2A; --herb:#1D9E75; --gold:#FAC775; --muted:#8A7A72;
    --serif:'DM Serif Display', Georgia, serif; --sans:'DM Sans', system-ui, sans-serif;
  }
  *{margin:0;padding:0;box-sizing:border-box;}
  body{background:#F1E4DE; color:var(--charcoal); font-family:var(--sans); font-size:14px; height:100vh; overflow:hidden;}
  a{color:inherit; text-decoration:none;}
  button{font-family:inherit; cursor:pointer; border:none; background:none;}
  input,textarea,select{font-family:inherit;}
  :focus-visible{outline:2.5px solid var(--spice); outline-offset:2px; border-radius:4px;}
  ::-webkit-scrollbar{width:7px;}
  ::-webkit-scrollbar-thumb{background:rgba(44,44,42,0.14); border-radius:10px;}
  ::-webkit-scrollbar-track{background:transparent;}

  .app{display:grid; grid-template-columns:1fr 420px; height:100vh; max-width:1320px; margin:0 auto;}

  /* ============ TOP BAR ============ */
  .topbar{
    position:fixed; top:0; left:0; right:0; height:64px; background:rgba(241,228,222,0.92); backdrop-filter:blur(8px);
    border-bottom:1px solid rgba(44,44,42,0.08); z-index:20; display:flex; align-items:center;
  }
  .topbar-inner{max-width:1320px; margin:0 auto; padding:0 28px; display:flex; align-items:center; justify-content:space-between; width:100%;}
  .tb-left{display:flex; align-items:center; gap:14px;}
  .close-btn{width:34px; height:34px; border-radius:50%; background:rgba(44,44,42,0.06); display:flex; align-items:center; justify-content:center; color:#6B5F58;}
  .tb-title{font-family:var(--serif); font-size:18px;}
  .tb-right{display:flex; align-items:center; gap:12px;}
  .draft-note{font-size:11.5px; color:#9A8C84; display:flex; align-items:center; gap:6px;}
  .draft-dot{width:6px; height:6px; border-radius:50%; background:var(--herb);}
  .publish-btn{background:var(--spice); color:#fff; font-size:13.5px; font-weight:700; padding:10px 22px; border-radius:30px; transition:transform .15s, box-shadow .15s, opacity .15s;}
  .publish-btn:hover{transform:translateY(-1px); box-shadow:0 10px 22px rgba(216,90,48,0.3);}
  .publish-btn:disabled{opacity:0.45; cursor:not-allowed; transform:none; box-shadow:none;}

  /* ============ FORM COLUMN ============ */
  .form-col{height:100vh; overflow-y:auto; padding:84px 48px 80px;}
  .form-wrap{max-width:560px; margin:0 auto;}

  .progress-rail{display:flex; gap:8px; margin-bottom:32px;}
  .progress-seg{flex:1; height:4px; border-radius:3px; background:rgba(44,44,42,0.1);}
  .progress-seg.done{background:var(--spice);}

  .form-section{margin-bottom:38px;}
  .fs-label{font-size:11.5px; font-weight:700; letter-spacing:0.06em; text-transform:uppercase; color:var(--spice-deep); margin-bottom:14px; display:flex; align-items:center; gap:8px;}
  .fs-num{width:22px; height:22px; border-radius:50%; background:rgba(216,90,48,0.12); display:flex; align-items:center; justify-content:center; font-size:11px; font-family:var(--serif);}

  .upload-box{
    height:220px; border-radius:20px; border:2px dashed rgba(216,90,48,0.35); background:#fff;
    display:flex; flex-direction:column; align-items:center; justify-content:center; gap:10px; cursor:pointer;
    transition:border-color .2s, background .2s; position:relative; overflow:hidden;
  }
  .upload-box:hover{border-color:var(--spice); background:rgba(216,90,48,0.03);}
  .upload-box.filled{border-style:solid; border-color:transparent;}
  .upload-icon{width:46px; height:46px; border-radius:50%; background:rgba(216,90,48,0.1); display:flex; align-items:center; justify-content:center; color:var(--spice-deep);}
  .upload-text{font-size:13.5px; font-weight:600; color:var(--charcoal);}
  .upload-sub{font-size:11.5px; color:#9A8C84;}
  .upload-remove{position:absolute; top:10px; right:10px; width:28px; height:28px; border-radius:50%; background:rgba(0,0,0,0.45); color:#fff; display:flex; align-items:center; justify-content:center; font-size:13px;}

  .field{margin-bottom:16px;}
  .field-label{font-size:12.5px; font-weight:600; color:var(--charcoal); margin-bottom:6px; display:block;}
  .field-input, .field-textarea, .field-select{
    width:100%; background:#fff; border:1.5px solid rgba(44,44,42,0.1); border-radius:13px; padding:12px 15px;
    font-size:13.5px; color:var(--charcoal); outline:none; transition:border-color .15s;
  }
  .field-input:focus, .field-textarea:focus, .field-select:focus{border-color:var(--spice);}
  .field-textarea{resize:vertical; min-height:64px; line-height:1.5;}
  .char-count{font-size:11px; color:#9A8C84; text-align:right; margin-top:4px;}
  .field-row{display:flex; gap:12px;}
  .field-row .field{flex:1;}

  .chip-row{display:flex; gap:8px; flex-wrap:wrap;}
  .chip{
    background:#fff; border:1.5px solid rgba(44,44,42,0.1); color:#6B5F58; font-size:12.5px; font-weight:600;
    padding:8px 14px; border-radius:20px; transition:all .15s;
  }
  .chip.selected{background:var(--spice); color:#fff; border-color:var(--spice);}

  .ingredient-row, .step-row{display:flex; gap:8px; margin-bottom:9px; align-items:flex-start;}
  .ingredient-row input{flex:1;}
  .ingredient-amount{width:84px !important; flex:0 0 84px;}
  .remove-row-btn{
    width:36px; height:36px; border-radius:10px; background:#fff; border:1.5px solid rgba(44,44,42,0.1); color:#B6A89F;
    display:flex; align-items:center; justify-content:center; flex-shrink:0;
  }
  .step-num-badge{
    width:36px; height:36px; border-radius:10px; background:var(--cream); color:var(--spice-deep); font-family:var(--serif);
    font-size:14px; display:flex; align-items:center; justify-content:center; flex-shrink:0;
  }
  .step-row textarea{flex:1; min-height:48px;}

  .add-row-btn{
    display:flex; align-items:center; gap:7px; font-size:12.5px; font-weight:700; color:var(--spice-deep);
    padding:9px 4px; margin-top:4px;
  }

  .toggle-row{display:flex; align-items:center; justify-content:space-between; background:#fff; border-radius:14px; padding:13px 16px; border:1px solid rgba(44,44,42,0.06); margin-bottom:10px;}
  .toggle-row-text b{font-size:13px; display:block;}
  .toggle-row-text span{font-size:11.5px; color:#9A8C84;}
  .toggle-switch{width:42px; height:24px; border-radius:14px; background:rgba(44,44,42,0.15); position:relative; flex-shrink:0; transition:background .2s;}
  .toggle-switch.on{background:var(--spice);}
  .toggle-knob{position:absolute; top:3px; left:3px; width:18px; height:18px; border-radius:50%; background:#fff; transition:transform .2s; box-shadow:0 1px 3px rgba(0,0,0,0.2);}
  .toggle-switch.on .toggle-knob{transform:translateX(18px);}

  /* ============ PREVIEW COLUMN ============ */
  .preview-col{height:100vh; overflow-y:auto; padding:84px 32px 60px; background:#F8EFEB; border-left:1px solid rgba(44,44,42,0.06);}
  .preview-sticky{position:sticky; top:0;}
  .preview-label{font-size:11.5px; font-weight:700; letter-spacing:0.06em; text-transform:uppercase; color:#9A8C84; margin-bottom:14px; text-align:center;}

  .preview-card{background:#fff; border-radius:22px; overflow:hidden; border:1px solid rgba(44,44,42,0.06); box-shadow:0 24px 50px -20px rgba(44,28,18,0.16);}
  .pv-top{display:flex; align-items:center; gap:10px; padding:14px 16px 12px;}
  .pv-avatar{width:36px; height:36px; border-radius:50%; background:#9FE1CB; flex-shrink:0;}
  .pv-who b{font-size:13px; font-weight:600; display:block;}
  .pv-who span{font-size:11px; color:#9A8C84;}
  .pv-thumb{height:220px; background:#EFE3DC; display:flex; align-items:center; justify-content:center; position:relative;}
  .pv-thumb-placeholder{color:#C9897A; text-align:center; font-size:12px;}
  .pv-thumb img, .pv-thumb-fill{width:100%; height:100%; object-fit:cover;}
  .pv-body{padding:14px 16px 16px;}
  .pv-title{font-family:var(--serif); font-size:17px; margin-bottom:5px; color:var(--charcoal); min-height:22px;}
  .pv-title.placeholder{color:#C9B8AF;}
  .pv-desc{font-size:12.5px; color:#6B5F58; line-height:1.5; margin-bottom:12px; min-height:18px;}
  .pv-desc.placeholder{color:#C9B8AF;}
  .pv-chips{display:flex; gap:6px; flex-wrap:wrap; margin-bottom:12px;}
  .pv-chip{font-size:10.5px; font-weight:600; background:var(--cream); color:var(--spice-deep); padding:4px 10px; border-radius:20px;}
  .pv-stats{display:flex; gap:14px; margin-bottom:12px; font-size:11.5px; color:#9A8C84;}
  .pv-stats b{color:var(--spice-deep);}
  .pv-actions{display:flex; align-items:center; gap:16px; padding-top:10px; border-top:1px solid rgba(44,44,42,0.06);}
  .pv-action{display:flex; align-items:center; gap:5px; font-size:12px; color:#6B5F58; font-weight:500;}
  .pv-made-pill{margin-left:auto; background:var(--spice); color:#fff; font-size:11px; font-weight:700; padding:6px 13px; border-radius:20px;}

  .preview-tip{
    background:rgba(255,255,255,0.6); border-radius:14px; padding:13px 16px; margin-top:18px; font-size:12px;
    color:#6B5F58; line-height:1.55; display:flex; gap:9px;
  }

  @media (max-width:980px){
    .app{grid-template-columns:1fr;}
    .preview-col{display:none;}
  }
</style>
</head>
<body>

<div class="topbar">
  <div class="topbar-inner">
    <div class="tb-left">
      <button class="close-btn" aria-label="Close">
        <svg width="15" height="15" viewBox="0 0 16 16"><path d="M2 2l12 12M14 2L2 14" stroke="#6B5F58" stroke-width="1.6" stroke-linecap="round"/></svg>
      </button>
      <span class="tb-title">New recipe</span>
    </div>
    <div class="tb-right">
      <span class="draft-note"><span class="draft-dot"></span>Draft saved</span>
      <button class="publish-btn" id="publishBtn" disabled>Publish recipe</button>
    </div>
  </div>
</div>

<div class="app">

  <!-- ================= FORM COLUMN ================= -->
  <main class="form-col">
    <div class="form-wrap">

      <div class="progress-rail">
        <div class="progress-seg done"></div>
        <div class="progress-seg done"></div>
        <div class="progress-seg"></div>
        <div class="progress-seg"></div>
        <div class="progress-seg"></div>
      </div>

      <!-- MEDIA -->
      <div class="form-section">
        <div class="fs-label"><span class="fs-num">1</span>Video or photo</div>
        <div class="upload-box" id="uploadBox">
          <div class="upload-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M4 7h3l1.5-2.5h7L17 7h3a1 1 0 011 1v11a1 1 0 01-1 1H4a1 1 0 01-1-1V8a1 1 0 011-1z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="12" cy="13" r="3.4" stroke="currentColor" stroke-width="1.6"/></svg>
          </div>
          <p class="upload-text">Tap to record or upload</p>
          <p class="upload-sub">MP4 or photo · up to 60 seconds · 9:16 or 1:1</p>
        </div>
      </div>

      <!-- DETAILS -->
      <div class="form-section">
        <div class="fs-label"><span class="fs-num">2</span>Recipe details</div>

        <div class="field">
          <label class="field-label">Recipe name</label>
          <input class="field-input" id="titleInput" type="text" placeholder="e.g. Cacio e Pepe — nonna's version" maxlength="60">
        </div>

        <div class="field">
          <label class="field-label">Description</label>
          <textarea class="field-textarea" id="descInput" placeholder="What makes this special? Share the story or the trick that makes it work." maxlength="200"></textarea>
          <div class="char-count"><span id="descCount">0</span> / 200</div>
        </div>

        <div class="field-row">
          <div class="field">
            <label class="field-label">Cook time</label>
            <div style="display:flex; gap:8px;">
              <input class="field-input" id="cookTime" type="number" placeholder="15" min="1">
              <select class="field-select" style="flex:0 0 90px;">
                <option>min</option>
                <option>hr</option>
              </select>
            </div>
          </div>
          <div class="field">
            <label class="field-label">Servings</label>
            <input class="field-input" id="servings" type="number" placeholder="2" min="1">
          </div>
        </div>
      </div>

      <!-- CUISINE TAGS -->
      <div class="form-section">
        <div class="fs-label"><span class="fs-num">3</span>Cuisine &amp; tags</div>
        <div class="chip-row" id="cuisineChips">
          <button class="chip selected">🍝 Italian</button>
          <button class="chip">🍛 South Asian</button>
          <button class="chip">🌮 Mexican</button>
          <button class="chip">🥘 Middle Eastern</button>
          <button class="chip">🍜 East Asian</button>
          <button class="chip">🥗 Healthy</button>
          <button class="chip">🍖 BBQ</button>
          <button class="chip">🥐 Bakery</button>
        </div>
      </div>

      <!-- INGREDIENTS -->
      <div class="form-section">
        <div class="fs-label"><span class="fs-num">4</span>Ingredients</div>
        <div id="ingredientRows">
          <div class="ingredient-row">
            <input class="field-input ingredient-amount" type="text" placeholder="200g">
            <input class="field-input" type="text" placeholder="Spaghetti" value="Spaghetti">
            <button class="remove-row-btn">✕</button>
          </div>
          <div class="ingredient-row">
            <input class="field-input ingredient-amount" type="text" placeholder="100g">
            <input class="field-input" type="text" placeholder="Ingredient" value="Pecorino Romano">
            <button class="remove-row-btn">✕</button>
          </div>
          <div class="ingredient-row">
            <input class="field-input ingredient-amount" type="text" placeholder="2 tsp">
            <input class="field-input" type="text" placeholder="Ingredient" placeholder="Ingredient">
            <button class="remove-row-btn">✕</button>
          </div>
        </div>
        <button class="add-row-btn" id="addIngredient">
          <svg width="14" height="14" viewBox="0 0 16 16"><path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
          Add ingredient
        </button>
      </div>

      <!-- STEPS -->
      <div class="form-section">
        <div class="fs-label"><span class="fs-num">5</span>Steps</div>
        <div id="stepRows">
          <div class="step-row">
            <div class="step-num-badge">1</div>
            <textarea class="field-textarea" placeholder="Describe this step...">Toast the cracked pepper in a dry pan for 30 seconds until fragrant.</textarea>
          </div>
          <div class="step-row">
            <div class="step-num-badge">2</div>
            <textarea class="field-textarea" placeholder="Describe this step..."></textarea>
          </div>
        </div>
        <button class="add-row-btn" id="addStep">
          <svg width="14" height="14" viewBox="0 0 16 16"><path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
          Add step
        </button>
      </div>

      <!-- SETTINGS -->
      <div class="form-section">
        <div class="fs-label"><span class="fs-num">6</span>Post settings</div>
        <div class="toggle-row">
          <div class="toggle-row-text"><b>Allow "Made it" replies</b><span>Let others post their version of this recipe</span></div>
          <div class="toggle-switch on" data-toggle><div class="toggle-knob"></div></div>
        </div>
        <div class="toggle-row">
          <div class="toggle-row-text"><b>Submit to a live challenge</b><span>Tag this as an entry to an active challenge</span></div>
          <div class="toggle-switch" data-toggle><div class="toggle-knob"></div></div>
        </div>
        <div class="toggle-row">
          <div class="toggle-row-text"><b>Share to Instagram &amp; TikTok</b><span>Cross-post a teaser when this goes live</span></div>
          <div class="toggle-switch" data-toggle><div class="toggle-knob"></div></div>
        </div>
      </div>

    </div>
  </main>

  <!-- ================= PREVIEW COLUMN ================= -->
  <aside class="preview-col">
    <div class="preview-sticky">
      <p class="preview-label">How this will look</p>

      <div class="preview-card">
        <div class="pv-top">
          <div class="pv-avatar"></div>
          <div class="pv-who"><b>Priya Rajan</b><span>South Asian · Just now</span></div>
        </div>
        <div class="pv-thumb" id="pvThumb">
          <div class="pv-thumb-placeholder">
            <svg width="34" height="34" viewBox="0 0 24 24" fill="none" style="margin:0 auto 6px; opacity:0.5;"><path d="M4 7h3l1.5-2.5h7L17 7h3a1 1 0 011 1v11a1 1 0 01-1 1H4a1 1 0 01-1-1V8a1 1 0 011-1z" stroke="#C9897A" stroke-width="1.6" stroke-linejoin="round"/><circle cx="12" cy="13" r="3.4" stroke="#C9897A" stroke-width="1.6"/></svg>
            Your video will appear here
          </div>
        </div>
        <div class="pv-body">
          <p class="pv-title placeholder" id="pvTitle">Your recipe name</p>
          <p class="pv-desc placeholder" id="pvDesc">A short description will show up here.</p>
          <div class="pv-chips" id="pvChips">
            <span class="pv-chip">🍝 Italian</span>
          </div>
          <div class="pv-stats">
            <span><b id="pvCook">—</b> cook time</span>
            <span><b id="pvServ">—</b> servings</span>
          </div>
          <div class="pv-actions">
            <span class="pv-action">♥ 0</span>
            <span class="pv-action">💬 0</span>
            <span class="pv-made-pill">Made it?</span>
          </div>
        </div>
      </div>

      <div class="preview-tip">
        <span>💡</span>
        <span>This is exactly how your recipe will appear in followers' feeds. Fill in the form on the left and watch it update live.</span>
      </div>
    </div>
  </aside>

</div>

<script>
  const titleInput = document.getElementById('titleInput');
  const descInput = document.getElementById('descInput');
  const descCount = document.getElementById('descCount');
  const cookTime = document.getElementById('cookTime');
  const servings = document.getElementById('servings');
  const pvTitle = document.getElementById('pvTitle');
  const pvDesc = document.getElementById('pvDesc');
  const pvCook = document.getElementById('pvCook');
  const pvServ = document.getElementById('pvServ');
  const publishBtn = document.getElementById('publishBtn');
  const uploadBox = document.getElementById('uploadBox');
  const pvThumb = document.getElementById('pvThumb');

  function checkPublishable(){
    const ready = titleInput.value.trim().length > 2 && uploadBox.classList.contains('filled');
    publishBtn.disabled = !ready;
  }

  titleInput.addEventListener('input', () => {
    pvTitle.textContent = titleInput.value || 'Your recipe name';
    pvTitle.classList.toggle('placeholder', !titleInput.value);
    checkPublishable();
  });

  descInput.addEventListener('input', () => {
    descCount.textContent = descInput.value.length;
    pvDesc.textContent = descInput.value || 'A short description will show up here.';
    pvDesc.classList.toggle('placeholder', !descInput.value);
  });

  cookTime.addEventListener('input', () => { pvCook.textContent = cookTime.value ? cookTime.value + ' min' : '—'; });
  servings.addEventListener('input', () => { pvServ.textContent = servings.value || '—'; });

  uploadBox.addEventListener('click', () => {
    if(uploadBox.classList.contains('filled')) return;
    uploadBox.classList.add('filled');
    uploadBox.innerHTML = \`
      <div style="position:absolute; inset:0; background:linear-gradient(150deg,#E8916F,#B23D18); display:flex; align-items:center; justify-content:center;">
        <svg width="44" height="44" viewBox="0 0 100 100"><ellipse cx="50" cy="76" rx="32" ry="6" fill="#7A2A0A" opacity="0.4"/><path d="M18 50 Q18 80 50 80 Q82 80 82 50 Z" fill="#fff" opacity="0.9"/><path d="M16 47 Q16 53 21 53 L79 53 Q84 53 84 47 Q84 38 50 38 Q16 38 16 47 Z" fill="#fff"/></svg>
      </div>
      <button class="upload-remove" id="removeUpload">✕</button>
    \`;
    pvThumb.innerHTML = \`<div class="pv-thumb-fill" style="background:linear-gradient(150deg,#E8916F,#B23D18); display:flex; align-items:center; justify-content:center;"><svg width="40" height="40" viewBox="0 0 100 100"><ellipse cx="50" cy="76" rx="32" ry="6" fill="#7A2A0A" opacity="0.4"/><path d="M18 50 Q18 80 50 80 Q82 80 82 50 Z" fill="#fff" opacity="0.9"/><path d="M16 47 Q16 53 21 53 L79 53 Q84 53 84 47 Q84 38 50 38 Q16 38 16 47 Z" fill="#fff"/></svg></div>\`;
    checkPublishable();
    document.getElementById('removeUpload').addEventListener('click', (e) => {
      e.stopPropagation();
      resetUpload();
    });
  });

  function resetUpload(){
    uploadBox.classList.remove('filled');
    uploadBox.innerHTML = \`
      <div class="upload-icon"><svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M4 7h3l1.5-2.5h7L17 7h3a1 1 0 011 1v11a1 1 0 01-1 1H4a1 1 0 01-1-1V8a1 1 0 011-1z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="12" cy="13" r="3.4" stroke="currentColor" stroke-width="1.6"/></svg></div>
      <p class="upload-text">Tap to record or upload</p>
      <p class="upload-sub">MP4 or photo · up to 60 seconds · 9:16 or 1:1</p>
    \`;
    pvThumb.innerHTML = \`<div class="pv-thumb-placeholder"><svg width="34" height="34" viewBox="0 0 24 24" fill="none" style="margin:0 auto 6px; opacity:0.5;"><path d="M4 7h3l1.5-2.5h7L17 7h3a1 1 0 011 1v11a1 1 0 01-1 1H4a1 1 0 01-1-1V8a1 1 0 011-1z" stroke="#C9897A" stroke-width="1.6" stroke-linejoin="round"/><circle cx="12" cy="13" r="3.4" stroke="#C9897A" stroke-width="1.6"/></svg>Your video will appear here</div>\`;
    checkPublishable();
  }

  document.getElementById('cuisineChips').addEventListener('click', (e) => {
    if(!e.target.classList.contains('chip')) return;
    e.target.classList.toggle('selected');
    const pvChips = document.getElementById('pvChips');
    const selected = [...document.querySelectorAll('#cuisineChips .chip.selected')];
    pvChips.innerHTML = selected.length
      ? selected.map(c => \`<span class="pv-chip">\${c.textContent}</span>\`).join('')
      : '<span class="pv-chip" style="opacity:0.4;">Add a cuisine tag</span>';
  });

  document.querySelectorAll('[data-toggle]').forEach(t => {
    t.addEventListener('click', () => t.classList.toggle('on'));
  });

  document.getElementById('addIngredient').addEventListener('click', () => {
    const row = document.createElement('div');
    row.className = 'ingredient-row';
    row.innerHTML = \`
      <input class="field-input ingredient-amount" type="text" placeholder="Amount">
      <input class="field-input" type="text" placeholder="Ingredient">
      <button class="remove-row-btn">✕</button>
    \`;
    document.getElementById('ingredientRows').appendChild(row);
    row.querySelector('.remove-row-btn').addEventListener('click', () => row.remove());
  });
  document.querySelectorAll('#ingredientRows .remove-row-btn').forEach(btn => {
    btn.addEventListener('click', () => btn.closest('.ingredient-row').remove());
  });

  document.getElementById('addStep').addEventListener('click', () => {
    const rows = document.querySelectorAll('#stepRows .step-row');
    const row = document.createElement('div');
    row.className = 'step-row';
    row.innerHTML = \`
      <div class="step-num-badge">\${rows.length + 1}</div>
      <textarea class="field-textarea" placeholder="Describe this step..."></textarea>
    \`;
    document.getElementById('stepRows').appendChild(row);
  });
</script>

</body>
</html>
`;
